import { create } from "zustand";
import { type KlusSoortenModel } from "../models/KlusSoortModel.ts";

type KlusSoortenState = {
  klusSoorten: KlusSoortenModel;
  setKlusSoorten: (res: KlusSoortenModel) => void;
};

export const useKlusSoortenStore = create<KlusSoortenState>((set) => ({
  klusSoorten: [],
  setKlusSoorten: (res) => set({ klusSoorten: res }),
}));
